import AnimationScreenBridge from 'bridges/animationScreenBridge';
import ToastBridge from 'bridges/toastBridge';
import { AppBar, Button, Input } from 'components/common';
import useBottomSheet from 'hooks/common/useBottomSheet';
import useEditNickname from 'hooks/profile/useEditNickname';
import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Body from "../../components/common/Body";
import PageLayout from "../../components/common/PageLayout";

const EditNickname = () => {
  const { open } = useBottomSheet();
  const { validateNickname, checkUserStatus, updateNickname } = useEditNickname();
  const [name, setName] = useState<string>(myinfo.nick);
  const [errorText, setErrorText] = useState<string | null>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const nickStatus = useLocation().state;
  const MAX_NICK_LENGTH = 24;
  const hasError = errorText !== null;
  const isDisabled = hasError || name === myinfo.nick;

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const handleBack = () => {
    Transition.back();
  };

  const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    const errorMessage = validateNickname(newValue);
    setName(newValue);
    setErrorText(errorMessage);
  };

  const coinPurchaseComplete = (coinData: any) => {
    if(coinData.data == null) return;
    const coinDetail = PageShop.getProductDetails(coinData.data);
    AnimationScreenBridge.show('CoinPurchaseComplete', {
      id: 'CoinPurchaseComplete',
      status: 'completed',
      data: {
        amount: coinDetail.amount,
        isFree: false
      }
    });
  };

  const saveNickname = () => {
    if (name === myinfo.nick) {
      inputRef.current?.focus();
      showToast();
    } else {
      validateUser();
    }
  };

  const validateUser = () => {
    const status = checkUserStatus(nickStatus);

    switch (status) {
      case 'free':
        handleChangeRequest('free');
        break;
      case 'notEnoughCoin':
        open('NeedCoin', { id: 'NeedCoin', data: { productIds: ['lcoin_310'], body: brsc.nick_require_coin } })
          .then((data) => coinPurchaseComplete(data));
        break;
      case 'needPayment':
        open('NicknameChange', {
          id: 'NicknameChange',
          data: { onConfirm: () => handleChangeRequest('paid') },
        });
        break;
    }
  };

  const handleChangeRequest = (type: 'free' | 'paid') => {
    updateNickname(
      name,
      type,
      () => handleBack(),
      (msg) => CommonUI.showDialog({ btnNum: 1, msg })
    );
  };

  const showToast = () => {
    ToastBridge.add({
      text: brsc.nick_same_before,
      options: {
        duration: 2000,
        position: 'top',
        type: 'alert',
      },
    });
  };

  return (
    <PageLayout>
      <AppBar onBack={handleBack} leadingIcon="icons/ic_arrow_left.svg" className="border-none" />
      <Body className="flex flex-col bg-base-bg-default px-4 pb-4">
        <Input.Root error={hasError} className="mt-2 w-full">
          <div className="flex w-full items-center justify-between">
            <Input.Label>Nickname</Input.Label>
            <Input.ErrorText>{errorText}</Input.ErrorText>
          </div>
          <Input.Field ref={inputRef} value={name} onChange={handleChangeInput} maxLength={MAX_NICK_LENGTH} placeholder="Name" />
        </Input.Root>

        <hr className="my-4 w-full border border-base-border-default" />

        <div className="typography-caption-body flex w-full flex-col gap-2 px-2 text-base-txt-tertiary">
          <div className="flex gap-1">
            <span>&bull;</span>
            {brsc.nick_explain_desc1.replace('$param', Def.COIN_CREDIT_NICKCHANGE)}
          </div>
          <div className="flex gap-1">
            <span>&bull;</span>
            {brsc.nick_explain_desc2}
          </div>
          <div className="flex gap-1">
            <span>&bull;</span>
            {brsc.nick_explain_desc3}
          </div>
          <div className="flex gap-1">
            <span>&bull;</span>
            {brsc.nick_explain_desc4}
          </div>
        </div>

        <Button
          className={`typography-headline-lg mt-auto ${isDisabled ? 'pointer-events-none cursor-not-allowed' : ''}`}
          onClick={saveNickname}
          style={{
            type: 'solid',
            text: brsc.confirm2,
            borderRadius: 'full',
            color: isDisabled ? 'btn-bg-disabled' : 'btn-bg-primary',
            fontColor: isDisabled ? 'btn-txt-disabled' : 'btn-txt-primary',
          }}
        />
      </Body>
    </PageLayout>
  );
};

export default EditNickname;